import { RateLockRequestAction } from 'pages/LoanStructure/interfaces'
import Api from 'services/api'

const API_LOAN_CHANGE_REQUEST = '/loan/loanChangeRequest'
const API_LOAN_STRUCTURE_CHANGE_REQUEST = '/loan/loanChangeRequest/structure'
const API_RATE_LOCK_REQUEST = '/loan/loanChangeRequest/rateLock'

export const getLoanChangeRequest = () => {
  return Api.get(API_LOAN_CHANGE_REQUEST)
}

export const postLoanChangeRequest = (data: any) => {
  return Api.post(API_LOAN_CHANGE_REQUEST, data)
}

export const getPendingLoanChangeRequest = () => {
  return Api.get(API_LOAN_STRUCTURE_CHANGE_REQUEST)
}

export const cancelLoanStructureChangeRequest = (data: Record<string, any>) => {
  return Api.put(API_LOAN_STRUCTURE_CHANGE_REQUEST, data)
}

export const cancelManuallyChangeRequest = (taskID: number) => {
  return Api.post(`${API_LOAN_CHANGE_REQUEST}/cancelManual`, { taskID })
}

export const getPendingRateLockRequests = () => {
  return Api.get(API_RATE_LOCK_REQUEST)
}

export const createRateLockRequest = (type: number, payload: Record<string, any>) => {
  return Api.post(API_RATE_LOCK_REQUEST, { type, payload })
}

export const closeRateLockRequest = (
  requestId: string,
  action: RateLockRequestAction.Cancel | RateLockRequestAction.Reject,
  comment: string = '',
) => {
  return Api.put(`${API_RATE_LOCK_REQUEST}/${requestId}`, { action, comment })
}

export const approveRateLockRequest = (requestId: string) => {
  return Api.post(`/loan/rateLockRequest/${requestId}/approve`, {})
}

export const completeRateLockRequest = (requestId: string) => {
  return Api.post(`${API_RATE_LOCK_REQUEST}/${requestId}/complete`, {})
}
